import React from 'react';
import { render, fireEvent } from '@testing-library/react';
import Events from '../Events';

const sampleEvents = [
  {
    id: 1,
    name: 'Sunday Worship',
    description: 'Join us for worship',
    time: '10:00 AM',
    location: 'Main Campus',
    month: 'Mar',
    day: '15',
    image_url: 'https://example.com/worship.jpg',
    url: 'https://example.com/worship',
    starts_at: new Date(new Date().getFullYear(), new Date().getMonth(), 15, 10, 0).toISOString(),
  },
  {
    id: 2,
    name: 'Youth Night',
    description: 'Fun for teens',
    time: '7:00 PM',
    location: 'Youth Center',
    month: 'Mar',
    day: '18',
    image_url: null,
    url: null,
    starts_at: new Date(new Date().getFullYear(), new Date().getMonth(), 18, 19, 0).toISOString(),
  },
  {
    id: 3,
    name: 'Bible Study',
    description: null,
    time: null,
    location: null,
    month: null,
    day: null,
    image_url: null,
    url: null,
    starts_at: null,
  },
];

describe('Events', () => {
  describe('empty state', () => {
    it('shows empty message when data is null', () => {
      const { getByText } = render(<Events data={null} />);
      expect(getByText('No upcoming events at this time.')).toBeTruthy();
    });

    it('shows empty message when data is empty array', () => {
      const { getByText } = render(<Events data={[]} />);
      expect(getByText('No upcoming events at this time.')).toBeTruthy();
    });
  });

  describe('cards layout (default)', () => {
    it('renders event cards', () => {
      const { getByText, getAllByText } = render(<Events data={sampleEvents} />);
      expect(getByText('Sunday Worship')).toBeTruthy();
      expect(getByText('Youth Night')).toBeTruthy();
      expect(getByText('Bible Study')).toBeTruthy();
    });

    it('renders event image when available', () => {
      const { getByAltText } = render(<Events data={sampleEvents} />);
      expect(getByAltText('Sunday Worship')).toBeTruthy();
    });

    it('renders date badge with month and day', () => {
      const { getByText } = render(<Events data={[sampleEvents[0]]} />);
      expect(getByText('Mar')).toBeTruthy();
      expect(getByText('15')).toBeTruthy();
    });

    it('renders time and location', () => {
      const { getByText } = render(<Events data={[sampleEvents[0]]} />);
      expect(getByText(/10:00 AM/)).toBeTruthy();
      expect(getByText(/Main Campus/)).toBeTruthy();
    });

    it('renders description', () => {
      const { getByText } = render(<Events data={[sampleEvents[0]]} />);
      expect(getByText('Join us for worship')).toBeTruthy();
    });

    it('renders Details link with event url', () => {
      const { container } = render(<Events data={[sampleEvents[0]]} />);
      const link = container.querySelector('a.button');
      expect(link).toBeTruthy();
      expect(link.getAttribute('href')).toBe('https://example.com/worship');
    });

    it('renders Details button with onItemClick', () => {
      const handleClick = jest.fn();
      const { getAllByText } = render(<Events data={sampleEvents} onItemClick={handleClick} />);
      fireEvent.click(getAllByText('Details')[0]);
      expect(handleClick).toHaveBeenCalledWith(1);
    });

    it('limits visible events by pco-count setting', () => {
      const { container } = render(
        <Events data={sampleEvents} settings={{ 'pco-count': '2' }} />
      );
      const cards = container.querySelectorAll('.pco-card');
      expect(cards.length).toBe(2);
    });

    it('shows all events when pco-count is all', () => {
      const { container } = render(
        <Events data={sampleEvents} settings={{ 'pco-count': 'all' }} />
      );
      const cards = container.querySelectorAll('.pco-card');
      expect(cards.length).toBe(3);
    });
  });

  describe('list layout', () => {
    it('renders events in list format', () => {
      const { getByText, container } = render(
        <Events data={sampleEvents} settings={{ 'pco-layout': 'list' }} />
      );
      expect(container.querySelector('.pco-events-list')).toBeTruthy();
      expect(getByText('Sunday Worship')).toBeTruthy();
    });

    it('shows time and location in list', () => {
      const { getByText } = render(
        <Events data={[sampleEvents[0]]} settings={{ 'pco-layout': 'list' }} />
      );
      expect(getByText(/10:00 AM/)).toBeTruthy();
      expect(getByText(/Main Campus/)).toBeTruthy();
    });

    it('shows date in list items', () => {
      const { getByText } = render(
        <Events data={[sampleEvents[0]]} settings={{ 'pco-layout': 'list' }} />
      );
      expect(getByText('Mar')).toBeTruthy();
      expect(getByText('15')).toBeTruthy();
    });
  });

  describe('calendar layout', () => {
    it('renders calendar grid', () => {
      const { container, getByText } = render(
        <Events data={sampleEvents} settings={{ 'pco-layout': 'calendar' }} />
      );
      expect(container.querySelector('.pco-calendar')).toBeTruthy();
      expect(getByText('Sun')).toBeTruthy();
      expect(getByText('Mon')).toBeTruthy();
    });

    it('shows current month and year in header', () => {
      const now = new Date();
      const monthName = now.toLocaleString('default', { month: 'long' });
      const year = now.getFullYear();
      const { getByText } = render(
        <Events data={sampleEvents} settings={{ 'pco-layout': 'calendar' }} />
      );
      expect(getByText(`${monthName} ${year}`)).toBeTruthy();
    });

    it('renders day cells for the month', () => {
      const { container } = render(
        <Events data={sampleEvents} settings={{ 'pco-layout': 'calendar' }} />
      );
      const dayCells = container.querySelectorAll('.pco-cal-num');
      const daysInMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate();
      expect(dayCells.length).toBe(daysInMonth);
    });
  });
});
